import { ModalSizeType } from '../SystemModal/types';

export const DEFAULT_SIZE: ModalSizeType = 'medium';

export const SIZES_PX: Record<Exclude<ModalSizeType, 'full'>, number> = {
  small: 320,
  medium: 540,
  large: 740,
} as const;
